module.exports = __webpack_public_path__ + "img/WhiteIcon.7beda13f.svg";